import { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString } from "../../helper/Components";
import DateFilterUI from "../../helper/SearchFilter/DateFilterUI";
import { ApiLFC } from "../../letterForCounselling/ApiLFC";
import useForm from "../../shared/useForm";
import { ApiUnit } from "../../unit/ApiUnit";

const LfcKpiReportSearch = ({
  unitId,
  setUnit,
  setSearchLfcModel,
  searchLfcModel,
  setSearchButton,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [unitList, setUnitList] = useState([]);
  const unitTypeName = "null";
  const [lfcList, setLfcList] = useState([]);
  const [selectedLfc, setSelectedLfc] = useState({});
  const { values, setValues } = useForm(searchLfcModel);

  useEffect(() => {
    ApiLFC()
      .getlist()
      .then((res) => {
        setLfcList(res.data);
        setValues({ ...values, lfcType: res.data[0].value });
        setSelectedLfc(res.data[0]);
      })
      .catch((err) => console.log(err));
      // eslint-disable-next-line
  }, []);

  useEffect(() => {
    ApiUnit()
      .getUnitList(unitId, loggedInUnitId, false, unitTypeName)
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => console.log(err));
  }, [unitId, loggedInUnitId]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, loggedInUnitId, false, unitTypeName)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setUnit({ unitId: record.value, unitName: record.label });
      setValues({ ...values, unitId: record.value });
    }
  };
  const handleSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setValues({
      ...values,
      isSubUnits: v,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (values.unitId === 0) values.unitId = unitId;

    setSearchButton(true);
    setSearchLfcModel(values);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">
              {<GetLanguageString props="settings_letter_for_counselling" />}
            </Label>
            <Select
              value={selectedLfc}
              options={lfcList}
              className="basic-single ur"
              classNamePrefix="select"
              onChange={(e) => {
                setValues({
                  ...values,
                  lfcType: e.value,
                });
                setSelectedLfc(e);
              }}
            />
          </FormGroup>
        </Col>

        <Col md="8">
          <DateFilterUI
            setValues={setValues}
            values={values}
            showFullDate={false}
          />
        </Col>
      </Row>

      <Row>
        {unitList.map((record, index) => {
          const unitOptions = [];
          record.unitList.forEach((d) =>
            unitOptions.push({
              value: d.id,
              label: d.name,
              unitTypeName: d.unitTypeName,
            })
          );
          let selected = {};
          let unitName = "";
          if (record.parentUnitName !== null) unitName = record.parentUnitName;
          if (record.selectedUnit !== null) {
            selected = {
              value: record.selectedUnit.id,
              label: record.selectedUnit.name,
            };
          }

          return (
            <Col md="2" key={index}>
              <FormGroup>
                <Label className="col-form-label">
                  {unitName !== "" ? (
                    <GetLanguageString
                      props="member_select_unit_name"
                      value={unitName}
                    />
                  ) : (
                    <GetLanguageString props="member_select_unit" />
                  )}
                </Label>
                <Select
                  options={unitOptions}
                  value={selected}
                  className="basic-single ur"
                  classNamePrefix="select"
                  onChange={handleChangeUnits}
                />
              </FormGroup>
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col md="2">
          <FormGroup check>
            <Label check for="subUnit">
              <Input
                id="subUnit"
                type="checkbox"
                name="isSubUnits"
                checked={values.isSubUnits}
                value={!values.isSubUnits}
                onChange={handleSubUnits}
              />
              {<GetLanguageString props="member_search_member_sub_unit" />}
            </Label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <FormGroup>
            <Button color="primary" className="m-l-sm" type="submit">
              {<GetLanguageString props="common_search" />}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default LfcKpiReportSearch;
